(function ($) {
  'use strict';

  function parseSlideCount(value, fallback) {
    const parsed = Math.round(parseFloat(value));

    if (isNaN(parsed) || parsed < 1) {
      return fallback;
    }

    return parsed;
  }

  function initScentGridSliders(container) {
    if (typeof $ === 'undefined' || !$.fn || !$.fn.slick) {
      return;
    }

    const $context = container ? $(container) : $(document);

    $context.find('.camille-collection-showcase .scent-profiles-grid').each(function () {
      const $grid = $(this);

      if ($grid.hasClass('slick-initialized')) {
        return;
      }

      if ($grid.data('cards-layout') === 'grid') {
        return;
      }

      const slidesDesktop = parseSlideCount($grid.data('slides-desktop'), 3);
      const slidesTablet = parseSlideCount($grid.data('slides-tablet'), 2);
      const mobileLayout = $grid.data('mobile-layout') || 'stack';
      const responsive = [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: slidesTablet,
            slidesToScroll: 1,
            infinite: false
          }
        }
      ];

      if (mobileLayout === 'stack') {
        responsive.push({
          breakpoint: 820,
          settings: 'unslick'
        });
      }

      function updateScentGridAria(slick) {
        if (!slick || !slick.$slider) return;
        const $slider = slick.$slider;
        const $track = $slider.find('.slick-track');

        $track.attr('aria-live', 'off');

        $slider.find('.slick-slide').each(function () {
          const $slide = $(this);
          const isActive = $slide.hasClass('slick-active');
          $slide.attr({
            'aria-hidden': isActive ? 'false' : 'true'
          });
          const $focusable = $slide.find('a, button, input, select, textarea');
          if (isActive) {
            $focusable.removeAttr('tabindex');
          } else {
            $focusable.attr('tabindex', '-1');
          }
        });

        const slideIndex = slick.currentSlide;
        const totalSlides = slick.$slides ? slick.$slides.length : 0;
        const $prevBtn = $slider.find('.slick-prev');
        const $nextBtn = $slider.find('.slick-next');

        if ($prevBtn.length) {
          const isDisabled = slideIndex === 0;
          $prevBtn.attr({
            'aria-disabled': isDisabled ? 'true' : 'false',
            tabindex: isDisabled ? '-1' : '0'
          });
        }
        if ($nextBtn.length) {
          const isDisabled = slideIndex >= totalSlides - 1;
          $nextBtn.attr({
            'aria-disabled': isDisabled ? 'true' : 'false',
            tabindex: isDisabled ? '-1' : '0'
          });
        }
      }

      $grid.on('init afterChange', function (event, slick) {
        updateScentGridAria(slick);
      });

      $grid.slick({
        dots: false,
        infinite: false,
        slidesToShow: slidesDesktop,
        slidesToScroll: 1,
        prevArrow:
          '<button type="button" class="slick-arrow slick-prev" aria-label="Previous slide"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="16" viewBox="0 0 10.014 15.738"><path d="M22848-22416.84l7.85,7.193-7.85,7.064" transform="translate(-22847.324 22417.576)" fill="none" stroke="#fff" stroke-width="2"/></svg></button>',
        nextArrow:
          '<button type="button" class="slick-arrow slick-next" aria-label="Next slide"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="16" viewBox="0 0 10.014 15.738"><path d="M22848-22416.84l7.85,7.193-7.85,7.064" transform="translate(-22847.324 22417.576)" fill="none" stroke="#fff" stroke-width="2"/></svg></button>',
        responsive: responsive
      });
    });
  }

  function readyInit() {
    if (typeof jQuery !== 'undefined' && jQuery.fn && jQuery.fn.slick) {
      initScentGridSliders();
    } else {
      setTimeout(readyInit, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', readyInit);
  } else {
    readyInit();
  }

  if (typeof document !== 'undefined' && !window.__scentSliderBound) {
    window.__scentSliderBound = true;

    document.addEventListener('shopify:section:load', function (e) {
      if (window.jQuery) {
        initScentGridSliders(e.target);
      }
    });

    document.addEventListener('shopify:section:unload', function (e) {
      if (window.jQuery) {
        window.jQuery(e.target).find('.scent-profiles-grid.slick-initialized').slick('unslick');
      }
    });
  }
})(window.jQuery || window.$);
